/**
 * Functions helper
 */

import _ from 'lodash'
import Api from './helpers/Api'

const k = {
    fetchCurrentLanguage() {
        return new Promise((resolve, reject) => {
            // Prepare Request
            var headers = new Headers()

            var options = {
                method: 'GET',
                headers: headers,
                mode: 'cors',
                cache: 'default',
            }

            // Prepare URL
            let apiUrl = new URL(kpc_loc.endpoint + '/choices/current_language/')

            // Fetch
            fetch(apiUrl, options)
                .then((response) => {
                    return response.json()
                })
                .then((result) => {
                    resolve(result)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
}

export function classList(classes) {
    return Object.entries(classes) // transforms our input object in an array of key-value pairs
        .filter((entry) => entry[1]) // filters the resulting array to eliminate false items
        .map((entry) => entry[0]) // keep only classes
        .join(' ')
}

export function generateKey(pre) {
    return `${pre}_${new Date().getTime()}`
}

export function getCurrentLangWithAttribute() {
    return kpc_curr_lang || null
}
